"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentBrowser = void 0;
const AttachmentBrowser_yaml_component_1 = __importDefault(require("./AttachmentBrowser.yaml?component"));
exports.AttachmentBrowser = AttachmentBrowser_yaml_component_1.default;
